import resumeLink from './Chris_Beley_Resume_3-3-23.pdf';

export default resumeLink;
